import React, { Component, useRef, useState } from 'react'
import { Button, Container, Grid, Header, Image, Message, Segment } from 'semantic-ui-react'
import { connect } from 'react-redux';

import { Form, Input } from 'formsy-semantic-ui-react'

import { Link, useNavigate } from 'react-router-dom';



import {
    loginPostAction
} from '../../actions/LoginActions';


function LoginForm(props) {
    const [isLoging, setIsLoging] = useState(false);
    const [Mensagem, setMensagem] = useState([]);
    const formRef = useRef(null);
    const navigate = useNavigate();

    const { loginPostAction } = props;





    const efetuarLogin = (formData) => {
        setIsLoging(true);
        setMensagem([]);
        loginPostAction(formData).then(result => {
            setIsLoging(false);
            if (result.status === 'OK') {
                navigate(`/Main`);
            } else {

                let msg = [];
                msg.push(result.msg)

                setMensagem(msg);
                //this.props.history.push(`/`);
            }


        });



    }




    return (
        <Container style={{ marginTop: '0em' }}>

            <div className='login-form'>
                {/*
                Heads up! The styles below are necessary for the correct render of this example.
                You can do same with CSS, the main idea is that all the elements up to the `Grid`
                below must have a height of 100%.
                */}
                <style>{`
                body > div,
                body > div > div,
                body > div > div > div.login-form {
                    height: 100%;
                }
                `}</style>
                <Grid
                    textAlign='center'
                    style={{ height: '100%' }}
                    verticalAlign='middle'
                >
                    <Grid.Column style={{ maxWidth: 450 }}>
                        <Header as='h2' textAlign='center' style={{ marginTop: '65px' }}>
                            {' '}CRM
                        </Header>
                        {
                            (Mensagem.length > 0 ? (
                                <Message
                                    error
                                    header='Autenticação'
                                    list={Mensagem} />
                            ) : (
                                <div></div>
                            ))
                        }


                        <Form size='large' onSubmit={efetuarLogin}

                            name="formCRM"
                            ref={formRef}>

                            <Segment stacked>



                                <Form.Input
                                    fluid
                                    icon='user'
                                    iconPosition='left'
                                    placeholder='Login do Mitra'
                                    name='username'
                                    id='username'
                                    maxLength={50}


                                />
                                <Form.Input
                                    fluid
                                    icon='lock'
                                    iconPosition='left'
                                    placeholder='Password'
                                    type='password'
                                    name='password'
                                    id='password'
                                    maxLength={10}
                                />

                                <Button loading={isLoging} basic color='blue' fluid size='large'>Login</Button>
                            </Segment>
                        </Form>
                        {/*<Message>
                        New to us? <a href='#'>Sign Up</a>
                    </Message>*/}
                    </Grid.Column>
                </Grid>
            </div>
        </Container>
    )
}






const mapStateToProps = state => (
    {
        isAuthenticated: state.LoginReducer.isAuthenticated
        , codigoConsultor: state.LoginReducer.codigoConsultor
    }
);


//export default LoginForm;


export default connect(mapStateToProps, {
    loginPostAction
}
)(LoginForm);
